/*
* @描述: 报价单模板
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-12 09:13:55
*/
<template>
    <el-dialog :before-close="handleClickDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               custom-class="quotation_template_dialog"
               title="报价单模版"
               width="998px">
        <div class="quotation_template_wrap">
            <div class="left_type_wrap">
                <ul class="template_source_list">
                    <li :class="{'active':templateSource==='personalHistory'}"
                        class="template_source_item"
                        @click="handleClickTemplateSourceItem('personalHistory','个人历史')">个人历史
                    </li>
                    <li :class="{'active':templateSource==='companyRecommendation'}"
                        class="template_source_item"
                        @click="handleClickTemplateSourceItem('companyRecommendation','公司推荐')">公司推荐
                    </li>
                    <li :class="{'active':templateSource==='systemTemplate'}"
                        class="template_source_item"
                        @click="handleClickTemplateSourceItem('systemTemplate','系统模板')">系统模板
                    </li>
                </ul>
            </div>
            <div class="right_content_wrap">
                <div class="top_header_wrap page-filter_wrap">
                    <span class="template_source_text" v-text="templateSourceText"></span>
                    <el-input v-model="templateKeyword"
                              class="filter-input"
                              clearable
                              placeholder="请输入您想搜索的内容"
                              size="small"
                              @clear="handleClickSearch"
                              v-if="templateSource==='personalHistory'"
                              @keyup.enter.native="handleClickSearch">
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                </div>
                <div class="bottom_content_wrap">
                    <ul v-if="templateSource==='personalHistory'"
                        :style="{'width':personalHistoryTemplate.length>9?'calc(100% + 10px)':'100%'}"
                        class="personal_history_template_list">
                        <li v-for="(item,index) in personalHistoryTemplate"
                            :key="index"
                            class="personal_history_template_item">
                            <div class="template_title_wrap flex_js_wrap">
                                <div class="left_title_wrap">
                                    <i class="iconfont icon-baojiadan"></i>
                                    <span class="template_title" v-text="item.project_name||'--'"></span>
                                </div>
                                <div :class="'quotation_status_'+item.status"
                                     class="quotation_status"
                                     v-text="item.status_name"></div>
                            </div>
                            <div class="detail_form_item">
                                <div class="form_item_label">报价总金额：</div>
                                <div class="form_item_value">￥<span v-text="item.total_price"></span></div>
                            </div>
                            <div class="detail_form_item">
                                <div class="form_item_label">报价时间：</div>
                                <div class="form_item_value" v-text="item.quotation_at"></div>
                            </div>
                            <div class="template_handle_btn_wrap ta_c">
                                <el-button plain size="mini" type="primary" @click="handleClickTemplateDetail">详情
                                </el-button>
                                <el-button size="mini" type="primary" @click="handleClickUseHistoryTemplate(item)">使用
                                </el-button>
                            </div>
                        </li>
                    </ul>
                    <ul v-else-if="templateSource==='companyRecommendation'"
                        :style="{'width':companyRecommendationTemplate.length>3?'calc(100% + 10px)':'100%'}"
                        class="company_recommendation_template_list">
                        <li v-for="(item,index) in companyRecommendationTemplate"
                            class="company_recommendation_template_item">
                            <div class="template_title_wrap flex_js_wrap">
                                <div class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2024-50/2c8ccbb43dc5e4c0b9238e5b1fdaf927.png"
                                         width="16">
                                    <span class="template_name" v-text="item.name"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="handle_icon_wrap" v-if="item.is_system===0">
                                        <i class="iconfont icon-bianji" @click="handleClickEditTemplate(item)"></i>
                                    </span>
                                    <span class="handle_icon_wrap handle_icon_danger_wrap">
                                        <i class="iconfont icon-shanchu1" @click="handleClickDeleteTemplate(item)"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="template_content_wrap">
                                <div class="template_content_inner">
                                    <img :src="item.tmpl_url" alt="" class="tmpl_url">
                                    <div class="template_handle_btn_wrap">
                                        <el-button plain
                                                   size="small"
                                                   type="primary"
                                                   @click="handleClickPreviewTemplate(item,index)">预览
                                        </el-button>
                                        <el-button size="small" type="primary" @click="handleClickUseTemplate(item)">
                                            使用
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul v-else-if="templateSource==='systemTemplate'"
                        :style="{'width':systemTemplate.length>3?'calc(100% + 10px)':'100%'}"
                        class="company_recommendation_template_list">
                        <li v-for="(item,index) in systemTemplate" class="company_recommendation_template_item">
                            <div class="template_title_wrap flex_js_wrap">
                                <div class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2024-50/2c8ccbb43dc5e4c0b9238e5b1fdaf927.png"
                                         width="16">
                                    <span class="template_name" v-text="item.name"></span>
                                </div>
                                <div class="flex_wrap set_hot_wrap">
                                    <img alt=""
                                         v-if="!item.recommend_id"
                                         src="https://download.hecoos.com/enlightv/2024-50/169b4c7434f91e0069780df6a51a38f1.png"
                                         width="14">
                                    <el-link :underline="false"
                                             type="primary"
                                             v-if="!item.recommend_id"
                                             @click="handleClickSetRecommendation(item)">设为推荐
                                    </el-link>
                                </div>
                            </div>
                            <div class="template_content_wrap">
                                <div class="template_content_inner">
                                    <img :src="item.tmpl_url" alt="" class="tmpl_url">
                                    <div class="template_handle_btn_wrap">
                                        <el-button plain size="small" type="primary"
                                                   @click="handleClickPreviewTemplate(item,index)">预览
                                        </el-button>
                                        <el-button size="small" type="primary"
                                                   @click="handleClickUseTemplate(item)">
                                            使用
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="company_recommendation_template_item">
                            <div class="template_title_wrap flex_js_wrap">
                                <div class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2024-50/2c8ccbb43dc5e4c0b9238e5b1fdaf927.png"
                                         width="16">
                                    <span class="template_name">更多模板</span>
                                </div>
                            </div>
                            <div class="template_content_wrap">
                                <div class="template_content_inner">
                                    <el-skeleton>
                                        <template slot="template">
                                            <div style="padding: 8px;">
                                                <el-skeleton-item style="width: 30%;height: 8px" variant="p"/>
                                                <el-skeleton-item style="width: 50%;height: 8px" variant="p"/>
                                                <div class="flex_js_wrap">
                                                    <el-skeleton-item style="width: 50%;height: 22px" variant="p"/>
                                                    <el-skeleton-item style="width: 50%;height: 22px" variant="p"/>
                                                </div>
                                                <el-skeleton-item style="width: 100%;height: 22px" variant="p"/>
                                                <el-skeleton-item style="width: 100%;height: 40px" variant="p">
                                                </el-skeleton-item>
                                                <div class="stay_tuned">敬请期待。。。</div>
                                            </div>
                                        </template>
                                    </el-skeleton>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <el-dialog :before-close="handleClickReviewDialogClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="previewTemplateVisible"
                   v-if="previewTemplateVisible"
                   custom-class="template_review_dialog"
                   title="预览模板"
                   append-to-body
                   width="1120px">
            <div class="template_review_wrapper">
                <div :class="{'disabled':templateIndex===0}"
                     class="handle_check_icon_wrap left"
                     @click="handleClickLastTemplate">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div :class="{'disabled':templateIndex===templateReviewList.length-1}"
                     class="handle_check_icon_wrap right"
                     @click="handleClickNextTemplate">
                    <i class="el-icon-arrow-right"></i>
                </div>
                <img :src="templateReviewImage" alt="" class="template_review_image">
            </div>
            <div slot="footer">
                <el-button plain
                           size="small"
                           type="primary"
                           v-if="templateSource==='systemTemplate'"
                           @click="handleClickEditTemplate(templateReviewList[templateIndex])">编辑并推荐
                </el-button>
                <el-button size="small" type="primary"
                           @click="handleClickUseTemplate(templateReviewList[templateIndex])">使用该模版
                </el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
    import TemplateComponent from "./template_component";
    import {systemTemplateList, historyTmplList, recommendTmplList} from "@/api";

    export default {
        name: "QuotationTemplate",
        data() {
            return {
                templateSource: 'personalHistory', //companyRecommendation systemTemplate
                templateSourceText: '个人历史',
                templateKeyword: '',
                personalHistoryTemplate: [],
                companyRecommendationTemplate: [],
                systemTemplate: [
                    /*{
                        template_id: 1,
                        template_name: '模版一',
                        template_fields: [
                            {
                                "field_name": "公司地址",
                                "field_form": "quotation_template",
                                "field_key": "company_address",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入公司地址',
                                },
                                "status": 0,
                                "sort": 1,
                            },
                            {
                                "field_name": "报价人",
                                "field_form": "quotation_template",
                                "field_type": "contact",
                                "extend": {
                                    "default": true,
                                    "options": [],
                                    "col_span": 12,
                                    "placeholder": "请选择报价人",
                                    "select_range": [
                                        "2"
                                    ],
                                    "default_can_edit": "1"
                                },
                                "field_key": "quoter",
                                "sort": 2,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "联系电话",
                                "field_type": "telephone",
                                "field_form": "quotation_template",
                                "extend": {
                                    "col_span": 12,
                                    "is_unique": "0",
                                    "phone_type": "1",
                                    "direct_dial": false,
                                    "placeholder": "请输入联系电话"
                                },
                                "field_key": "contact_number",
                                "sort": 3,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "报价人联系电话",
                                "field_type": "telephone",
                                "field_form": "quotation_template",
                                "extend": {
                                    "col_span": 12,
                                    "is_unique": "0",
                                    "phone_type": "1",
                                    "direct_dial": false,
                                    "placeholder": "请输入报价人联系电话"
                                },
                                "field_key": "quoter_contact_number",
                                "sort": 4,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "为以下客户报价",
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                },
                                "status": 0,
                                "sort": 5,
                            },
                            {
                                "field_name": "项目名称",
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入新增/选择项目名称',
                                },
                                "status": 0,
                                "sort": 6,
                            },
                            {
                                "field_name": "客户联系人",
                                "field_form": "quotation_template",
                                "field_key": "contact_id",
                                "field_type": "customer_contact",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请选择客户联系人',
                                },
                                "status": 0,
                                "sort": 7,
                            },
                            {
                                "field_name": "客户名称",
                                "field_form": "quotation_template",
                                "field_key": "customer_id",
                                "field_type": "radio_customer",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入并选择客户或点击右侧新增',
                                },
                                "status": 0,
                                "sort": 8,
                            },
                            {
                                "field_name": "客户联系电话",
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入客户联系电话',
                                },
                                "status": 0,
                                "sort": 9,
                            },
                            {
                                "field_name": "报价时间",
                                "field_form": "quotation_template",
                                "field_type": "date",
                                "extend": {
                                    "default": false,
                                    "col_span": 12,
                                    "date_type": "date",
                                    "time_range": "any",
                                    "placeholder": "请选择报价时间",
                                },
                                "field_key": "quotation_date",
                                "sort": 14,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "失效时间",
                                "field_form": "quotation_template",
                                "field_type": "date",
                                "extend": {
                                    "default": false,
                                    "col_span": 12,
                                    "date_type": "date",
                                    "time_range": "after",
                                    "placeholder": "请选择失效时间",
                                },
                                "field_key": "expiration_date",
                                "sort": 15,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "说明",
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    placeholder: '请输入说明',
                                },
                                "status": 0,
                                "sort": 12,
                            },
                            {
                                "field_name": "产品列表",
                                "field_type": "table",
                                "field_form": "quotation_template",
                                "extend": {
                                    "col_span": 24,
                                    "filling_method": "horizontal",
                                    "import_by_template": false,
                                },
                                "field_key": "product_list",
                                "sort": 11,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": [],
                                "_child": [
                                    {
                                        "field_name": "产品类别",
                                        "field_type": "input",
                                        "extend": {
                                            "col_span": 12,
                                            "input_type": "text",
                                            "placeholder": "请输入产品类别",
                                            "is_unique": "0",
                                            table_width: '100'
                                        },
                                        "field_key": "product_category",
                                        "sort": 12,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "设备名称",
                                        "field_type": "input",
                                        "extend": {
                                            "col_span": 12,
                                            "input_type": "text",
                                            "placeholder": "请输入设备名称",
                                            table_width: '130'
                                        },
                                        "field_key": "device_name",
                                        "sort": 13,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "产品描述",
                                        "field_type": "textarea",
                                        "extend": {
                                            "col_span": 24,
                                            "placeholder": "请输入产品描述",
                                            table_width: '196'
                                        },
                                        "field_key": "product_description",
                                        "sort": 14,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "单价",
                                        "field_type": "money",
                                        "extend": {
                                            "some": 2,
                                            "error": "",
                                            "format": [
                                                "2",
                                                "3"
                                            ],
                                            "col_span": 12,
                                            "currency": [
                                                "￥",
                                                "$"
                                            ],
                                            "placeholder": "请输入单价",
                                            table_width: '150'
                                        },
                                        "field_key": "price",
                                        "sort": 15,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 1,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": [],
                                        "p_field_type": "table",
                                    },
                                    {
                                        "field_name": "数量",
                                        "field_type": "number",
                                        "extend": {
                                            "unit": "",
                                            "col_span": 12,
                                            "other_site": [],
                                            "placeholder": "请输入数量",
                                            table_width: '85'
                                        },
                                        "field_key": "count",
                                        "sort": 16,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 1,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": [],
                                        "p_field_type": "table",
                                    },
                                    {
                                        "field_name": "小计",
                                        "field_type": "compute_mode",
                                        "extend": {
                                            "some": 2,
                                            "format": [
                                                "2",
                                                "3"
                                            ],
                                            "formula": "明细/表格.单价*明细/表格.数量",
                                            "col_span": 12,
                                            "formula_list": [
                                                {
                                                    "type": "component",
                                                    "content": "明细/表格.单价",
                                                    "field_key": "price",
                                                    "field_type": "money",
                                                    "p_field_key": "product_list",
                                                    "p_field_type": "table"
                                                },
                                                {
                                                    "type": "symbol",
                                                    "content": "*",
                                                    "field_key": ""
                                                },
                                                {
                                                    "type": "component",
                                                    "content": "明细/表格.数量",
                                                    "field_key": "count",
                                                    "field_type": "number",
                                                    "p_field_key": "product_list",
                                                    "p_field_type": "table"
                                                }
                                            ],
                                            "field_formula": "price*count",
                                            table_width: '102'
                                        },
                                        "field_key": "subtotal",
                                        "sort": 17,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "备注",
                                        "field_type": "textarea",
                                        "extend": {
                                            "col_span": 24,
                                            "placeholder": "请输入备注",
                                            table_width: '150'
                                        },
                                        "field_key": "remarks",
                                        "sort": 18,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    }
                                ]
                            },
                            {
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "field_form": "quotation_template",
                                "extend": {
                                    "some": 2,
                                    "format": [
                                        "2",
                                        "3"
                                    ],
                                    "formula": "产品列表.小计",
                                    "col_span": 24,
                                    "formula_list": [
                                        {
                                            "type": "component",
                                            "content": "产品列表.小计",
                                            "field_key": "subtotal",
                                            "field_type": "compute_mode",
                                            "p_field_key": "product_list",
                                            "p_field_type": "table"
                                        }
                                    ],
                                    "field_formula": "subtotal",
                                },
                                "field_key": "total_amount",
                                "sort": 15,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            }
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/5d6711404f6617fcd53e5d91de1a5576.png'
                    },
                    {
                        template_id: 2,
                        template_name: '模版二',
                        template_fields: [
                            {
                                "field_name": "报价人",
                                "field_form": "quotation_template",
                                "field_type": "contact",
                                "extend": {
                                    "default": true,
                                    "options": [],
                                    "col_span": 12,
                                    "placeholder": "请选择报价人",
                                    "select_range": [
                                        "2"
                                    ],
                                    "default_can_edit": "1",
                                    can_draggable: false,
                                },
                                "field_key": "quoter",
                                "sort": 2,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "报价人联系电话",
                                "field_type": "telephone",
                                "field_form": "quotation_template",
                                "extend": {
                                    "col_span": 12,
                                    "is_unique": "0",
                                    "phone_type": "1",
                                    "direct_dial": false,
                                    "placeholder": "请输入报价人联系电话",
                                    can_draggable: false,
                                },
                                "field_key": "quoter_contact_number",
                                "sort": 4,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "报价时间",
                                "field_form": "quotation_template",
                                "field_type": "date",
                                "extend": {
                                    "default": false,
                                    "col_span": 12,
                                    "date_type": "date",
                                    "time_range": "any",
                                    "placeholder": "请选择报价时间",
                                    can_draggable: false,
                                },
                                "field_key": "quotation_date",
                                "sort": 14,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "为以下客户报价",
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                },
                                "status": 0,
                                "sort": 5,
                            },
                            {
                                "field_name": "项目名称",
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入新增/选择项目名称',
                                },
                                "status": 0,
                                "sort": 6,
                            },
                            {
                                "field_name": "客户联系人",
                                "field_form": "quotation_template",
                                "field_key": "contact_id",
                                "field_type": "customer_contact",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请选择客户联系人',
                                },
                                "status": 0,
                                "sort": 7,
                            },
                            {
                                "field_name": "客户名称",
                                "field_form": "quotation_template",
                                "field_key": "customer_id",
                                "field_type": "radio_customer",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入并选择客户或点击右侧新增',
                                },
                                "status": 0,
                                "sort": 8,
                            },
                            {
                                "field_name": "客户联系电话",
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12,
                                    placeholder: '请输入客户联系电话',
                                },
                                "status": 0,
                                "sort": 9,
                            },
                            {
                                "field_name": "失效时间",
                                "field_form": "quotation_template",
                                "field_type": "date",
                                "extend": {
                                    "default": false,
                                    "col_span": 12,
                                    "date_type": "date",
                                    "time_range": "after",
                                    "placeholder": "请选择失效时间",
                                },
                                "field_key": "expiration_date",
                                "sort": 15,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            },
                            {
                                "field_name": "说明",
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    placeholder: '请输入说明',
                                },
                                "status": 0,
                                "sort": 12,
                            },
                            {
                                "field_name": "产品列表",
                                "field_type": "table",
                                "field_form": "quotation_template",
                                "extend": {
                                    "col_span": 24,
                                    "filling_method": "horizontal",
                                    "import_by_template": false,
                                },
                                "field_key": "product_list",
                                "sort": 11,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": [],
                                "_child": [
                                    {
                                        "field_name": "产品名称",
                                        "field_type": "input",
                                        "extend": {
                                            "col_span": 12,
                                            "input_type": "text",
                                            "placeholder": "请输入产品名称",
                                            "is_unique": "0",
                                            table_width: '231'
                                        },
                                        "field_key": "product_name",
                                        "sort": 12,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "规格型号",
                                        "field_type": "input",
                                        "extend": {
                                            "col_span": 12,
                                            "input_type": "text",
                                            "placeholder": "请输入设备名称",
                                            table_width: '280'
                                        },
                                        "field_key": "product_spec",
                                        "sort": 13,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                    {
                                        "field_name": "单价",
                                        "field_type": "money",
                                        "extend": {
                                            "some": 2,
                                            "error": "",
                                            "format": [
                                                "2",
                                                "3"
                                            ],
                                            "col_span": 12,
                                            "currency": [
                                                "￥",
                                                "$"
                                            ],
                                            "placeholder": "请输入单价",
                                            table_width: '150'
                                        },
                                        "field_key": "price",
                                        "sort": 15,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 1,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": [],
                                        "p_field_type": "table",
                                    },
                                    {
                                        "field_name": "数量",
                                        "field_type": "number",
                                        "extend": {
                                            "unit": "",
                                            "col_span": 12,
                                            "other_site": [],
                                            "placeholder": "请输入数量",
                                            table_width: '126'
                                        },
                                        "field_key": "count",
                                        "sort": 16,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 1,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": [],
                                        "p_field_type": "table",
                                    },
                                    {
                                        "field_name": "小计",
                                        "field_type": "compute_mode",
                                        "extend": {
                                            "some": 2,
                                            "format": [
                                                "2",
                                                "3"
                                            ],
                                            "formula": "明细/表格.单价*明细/表格.数量",
                                            "col_span": 12,
                                            "formula_list": [
                                                {
                                                    "type": "component",
                                                    "content": "明细/表格.单价",
                                                    "field_key": "price",
                                                    "field_type": "money",
                                                    "p_field_key": "product_list",
                                                    "p_field_type": "table"
                                                },
                                                {
                                                    "type": "symbol",
                                                    "content": "*",
                                                    "field_key": ""
                                                },
                                                {
                                                    "type": "component",
                                                    "content": "明细/表格.数量",
                                                    "field_key": "count",
                                                    "field_type": "number",
                                                    "p_field_key": "product_list",
                                                    "p_field_type": "table"
                                                }
                                            ],
                                            "field_formula": "price*count",
                                            table_width: '126'
                                        },
                                        "field_key": "subtotal",
                                        "sort": 17,
                                        "is_system": 1,
                                        "quote_field_form": "",
                                        "quote_field_key": "",
                                        "is_system_key": 0,
                                        "is_unique": 0,
                                        "is_required": 0,
                                        "status": "0",
                                        "p_field_key": "product_list",
                                        "rules": []
                                    },
                                ]
                            },
                            {
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "field_form": "quotation_template",
                                "extend": {
                                    "some": 2,
                                    "format": [
                                        "2",
                                        "3"
                                    ],
                                    "formula": "产品列表.小计",
                                    "col_span": 24,
                                    "formula_list": [
                                        {
                                            "type": "component",
                                            "content": "产品列表.小计",
                                            "field_key": "subtotal",
                                            "field_type": "compute_mode",
                                            "p_field_key": "product_list",
                                            "p_field_type": "table"
                                        }
                                    ],
                                    "field_formula": "subtotal",
                                },
                                "field_key": "total_amount",
                                "sort": 15,
                                "is_system": 1,
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system_key": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "status": "0",
                                "p_field_key": "",
                                "rules": []
                            }
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/5d75ce5e54a587bf075462c8ecb1ef6b.png'
                    },
                    {
                        template_id: 3,
                        template_name: '模版三',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "备注",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/445ede1ea867623be46f63b451af1bf1.png'
                    },
                    {
                        template_id: 4,
                        template_name: '模版四',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "备注",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/d44d5ead00550408e287b77a4773412c.png'
                    },
                    {
                        template_id: 5,
                        template_name: '模版五',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_address",
                                "field_name": "地址",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/e19635046a4c72deaf7e21f5f2c0aea0.png'
                    },
                    {
                        template_id: 6,
                        template_name: '模版六',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "备注",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_address",
                                "field_name": "公司地址",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/71578c18ac49e2228acd7d041d5e664c.png'
                    },
                    {
                        template_id: 7,
                        template_name: '模版七',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_address",
                                "field_name": "公司地址",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "contact_number",
                                "field_name": "联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/34997edc2457ef2edf554d43e1937865.png'
                    },
                    {
                        template_id: 8,
                        template_name: '模版八',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    can_draggable: false
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/3687cb1fef3bda4013a8446f84ad6c95.png'
                    },
                    {
                        template_id: 9,
                        template_name: '模版九',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    can_draggable: false
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/dcce7f6012d4cc8c0bb3cf1b1365ac60.png'
                    },
                    {
                        template_id: 10,
                        template_name: '模版十',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    can_draggable: false
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/14e572fe5d9c6c678c915bda9adf8a40.png'
                    },
                    {
                        template_id: 11,
                        template_name: '模版十一',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    can_draggable: false
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "公司地址",
                                "field_type": "textarea",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/3c32b6e0ee08b7dc020cca3820e91ab9.png'
                    },
                    {
                        template_id: 12,
                        template_name: '模版十二',
                        template_fields: [
                            {
                                "field_form": "quotation_template",
                                "field_key": "company_explain",
                                "field_name": "为以下客户报价",
                                "field_type": "explain",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    can_draggable: false
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "project_title",
                                "field_name": "项目名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_person",
                                "field_name": "客户联系人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_name",
                                "field_name": "客户名称",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "client_contact_number",
                                "field_name": "客户联系电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "产品列表",
                                "field_type": "table",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "product_list",
                                "field_name": "总计",
                                "field_type": "compute_mode",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 24,
                                    handle_icon_show: false,
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter",
                                "field_name": "报价人",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quoter_contact_number",
                                "field_name": "报价人电话",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "quotation_date",
                                "field_name": "报价时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "expiration_date",
                                "field_name": "失效时间",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                            {
                                "field_form": "quotation_template",
                                "field_key": "description",
                                "field_name": "说明",
                                "field_type": "input",
                                "p_field_key": "",
                                "quote_field_form": "",
                                "quote_field_key": "",
                                "is_system": 1,
                                "is_system_key": 0,
                                "is_reset": 0,
                                "is_unique": 0,
                                "is_required": 0,
                                "extend": {
                                    "col_span": 12
                                },
                                "status": 0,
                                "sort": null,
                            },
                        ],
                        tmpl_url: 'https://download.hecoos.com/enlightv/2024-51/c545a36ecd1fd795deb424015b62fa29.png'
                    },*/
                ],
                previewTemplateVisible: false,
                templateIndex: 0,
                templateReviewImage: '',
                templateReviewList: []
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
        },
        components: {TemplateComponent},
        created() {
            this.getHistoryTmplList()
        },
        mounted() {
        },
        methods: {
            // 关闭弹窗
            handleClickDialogClose() {
                this.$emit('update:dialogVisible', false)
                this.$store.dispatch('saveRelateProjectData', {})
            },

            // 搜索
            handleClickSearch() {

            },

            // 点击模板类型
            handleClickTemplateSourceItem(type, title) {
                this.templateSource = type
                this.templateSourceText = title
                if (type === 'companyRecommendation') {
                    if (this.companyRecommendationTemplate.length === 0) {
                        this.getRecommendTmplList()
                    }
                } else if (type === 'systemTemplate') {
                    if (this.systemTemplate.length === 0) {
                        this.getSystemTemplateList()
                    }
                }
            },

            //获取个人历史模板
            getHistoryTmplList() {
                historyTmplList().then(res => {
                    if (res.code === 200) {
                        const {total, data} = res.data
                        this.personalHistoryTemplate = data
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            //获取公司推荐模板
            getRecommendTmplList() {
                recommendTmplList().then(res => {
                    if (res.code === 200) {
                        this.companyRecommendationTemplate = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            //获取紫铜模板
            getSystemTemplateList() {
                systemTemplateList().then(res => {
                    if (res.code === 200) {
                        this.systemTemplate = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            // 编辑模板
            handleClickEditTemplate(item) {
                this.$emit('update:dialogVisible', false)
                this.$router.push({
                    name: 'QuotationTemplateEdit',
                    query: {
                        project_quotation_tmpl_form: item.form,
                        is_system: this.templateSource === 'systemTemplate' ? 1 : 0
                    },
                })
            },

            // 删除模板
            handleClickDeleteTemplate(item) {
                recommendTmplSet({
                    project_quotation_tmpl_id: item.project_quotation_tmpl_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('取消推荐成功')
                        this.getRecommendTmplList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            // 点击模板详情
            handleClickTemplateDetail() {
            },

            //点击使用历史模板
            handleClickUseHistoryTemplate(item) {
                this.$emit('update:dialogVisible', false)
                this.$router.push({
                    name: 'QuotationAdd',
                    query: {
                        project_quotation_tmpl_form: item.project_quotation_tmpl_form,
                        form_snapshot_key: item.form_snapshot_key,
                    },
                })
            },

            //点击使用模板
            handleClickUseTemplate(item) {
                this.$emit('update:dialogVisible', false)
                this.$router.push({
                    name: 'QuotationAdd',
                    query: {
                        project_quotation_tmpl_form: item.form,
                    },
                })
            },

            //预览模板
            handleClickPreviewTemplate(item, index) {
                this.templateReviewImage = item.tmpl_url
                this.templateIndex = index
                if (this.templateSource === 'companyRecommendation') {
                    this.templateReviewList = this.companyRecommendationTemplate
                } else {
                    this.templateReviewList = this.systemTemplate
                }
                this.previewTemplateVisible = true
            },

            //关闭预览模板弹窗
            handleClickReviewDialogClose() {
                this.previewTemplateVisible = false
            },

            //设为推荐
            handleClickSetRecommendation(item) {
                recommendTmplSet({
                    project_quotation_tmpl_id: item.project_quotation_tmpl_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('设置成功')
                        this.getRecommendTmplList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },

            //点击上一个模板
            handleClickLastTemplate() {
                if (this.templateIndex > 0) {
                    this.templateIndex--
                    this.templateReviewImage = this.templateReviewList[this.templateIndex].tmpl_url
                } else {
                    this.templateIndex = 0
                }
            },

            //点击下一个模板
            handleClickNextTemplate() {
                if (this.templateIndex < this.templateReviewList.length - 1) {
                    this.templateIndex++
                    this.templateReviewImage = this.templateReviewList[this.templateIndex].tmpl_url
                } else {
                    this.templateIndex = this.templateReviewList.length - 1
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    .quotation_template_wrap {
        width: 100%;
        height: 664px;
        display: flex;

        .left_type_wrap {
            width: 230px;
            height: 100%;
            padding: 0 8px;

            .template_source_list {
                padding: 0 8px;

                .template_source_item {
                    padding: 8px 16px;
                    line-height: 22px;
                    color: #666666;
                    cursor: pointer;
                    border-radius: 6px;

                    &.active {
                        color: #2990FF;
                        font-weight: bold;
                        background-color: rgba(41, 144, 255, 0.16);
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.04);
                    }
                }
            }
        }

        .right_content_wrap {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            background-color: #F7F8FA;

            .top_header_wrap {
                width: 100%;
                height: 48px;
                background-color: #FFFFFF;
                padding: 0 24px 0 16px;
                align-items: center;

                .template_source_text {
                    font-weight: 700;
                    line-height: 22px;
                    color: #333333;
                }
            }

            .bottom_content_wrap {
                flex: 1;
                overflow: hidden;
                padding: 16px;

                .personal_history_template_list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 16px;
                    max-height: 100%;
                    overflow-y: auto;
                    overflow-x: hidden;

                    .personal_history_template_item {
                        border-radius: 6px;
                        width: calc(33.33% - 13px);
                        height: 150px;
                        background-color: #FFFFFF;
                        transition: all .3s;
                        padding: 16px;

                        &:hover {
                            box-shadow: 0 6px 16px 4px rgba(0, 0, 0, 0.08);
                        }

                        .template_title_wrap {
                            margin-bottom: 8px;

                            .left_title_wrap {
                                flex: 1;

                                .icon-baojiadan {
                                    color: #666666;
                                    font-size: 16px;
                                    margin-right: 4px;
                                    vertical-align: middle;
                                }

                                .template_title {
                                    display: inline-block;
                                    line-height: 22px;
                                    color: #333333;
                                    font-weight: 700;
                                    max-width: calc(100% - 20px);
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    vertical-align: middle;
                                }
                            }

                            .quotation_status {
                                padding: 0 8px;
                                line-height: 22px;
                                border-radius: 4px;

                                &.quotation_status_1 {
                                    background-color: rgba(240, 170, 50, 0.1);
                                    color: #F0AA32;
                                }

                                &.quotation_status_2 {
                                    background-color: rgba(228, 65, 68, 0.1);
                                    color: #E44144;
                                }

                                &.quotation_status_3 {
                                    background-color: rgba(191, 191, 191, 0.1);
                                    color: #BFBFBF;
                                }

                                &.quotation_status_4 {
                                    background-color: rgba(240, 170, 50, 0.1);
                                    color: #F0AA32;
                                }

                                &.quotation_status_5 {
                                    background-color: rgba(191, 191, 191, 0.1);
                                    color: #BFBFBF;
                                }

                                &.quotation_status_6 {
                                    background-color: rgba(90, 179, 51, 0.1);
                                    color: #5AB333;
                                }

                                &.quotation_status_7 {
                                    background-color: rgba(228, 65, 68, 0.1);
                                    color: #E44144;
                                }
                            }
                        }

                        .template_handle_btn_wrap {
                            margin-top: 16px;

                            .el-button--mini {
                                padding: 5px 8px;
                                border-radius: 4px;
                            }
                        }
                    }
                }

                .company_recommendation_template_list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 16px;
                    max-height: 100%;
                    overflow-y: auto;
                    overflow-x: hidden;

                    .company_recommendation_template_item {
                        border-radius: 6px;
                        width: calc(33.33% - 13px);
                        background-color: #FFFFFF;
                        transition: all .3s;
                        padding: 16px;

                        &:hover {
                            box-shadow: 0 6px 16px 4px rgba(0, 0, 0, 0.08);

                            .template_title_wrap .handle_icon_wrap {
                                display: inline-block;
                            }

                            .template_title_wrap .set_hot_wrap {
                                display: flex;
                            }

                            .template_content_wrap .template_content_inner .template_handle_btn_wrap {
                                display: flex;
                            }
                        }

                        .template_title_wrap {
                            margin-bottom: 4px;

                            .template_name {
                                font-weight: 700;
                                line-height: 22px;
                                color: #333333;
                            }

                            .handle_icon_wrap {
                                display: none;
                            }

                            .set_hot_wrap {
                                display: none;
                            }
                        }

                        .template_content_wrap {
                            border-radius: 4px;
                            background: #EDF0F4;
                            height: 158px;
                            padding: 4px;

                            .template_content_inner {
                                width: 100%;
                                height: 100%;
                                border-radius: 4px;
                                background: #FFFFFF;
                                position: relative;

                                .tmpl_url {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }

                                .template_handle_btn_wrap {
                                    align-items: center;
                                    justify-content: center;
                                    gap: 6px;
                                    position: absolute;
                                    bottom: -10px;
                                    left: 0;
                                    right: 0;
                                    background-color: #FFFFFF;
                                    display: none;

                                    .el-button--small {
                                        padding: 9px 28px;
                                        border-radius: 4px;

                                        &.is-plain {
                                            background-color: #FFFFFF;
                                        }
                                    }
                                }

                                .el-skeleton__item {
                                    display: block;
                                    margin-bottom: 8px;
                                    background: #EDF0F4;
                                }

                                .stay_tuned {
                                    text-align: center;
                                    font-size: 12px;
                                    line-height: 18px;
                                    color: #999999;
                                    position: absolute;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    bottom: 40%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .quotation_template_dialog {
        .el-dialog__header {
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 0;
        }
    }

    .template_review_dialog {
        .el-dialog__header {
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 0 60px;
        }

        .el-dialog__footer {
            border-top: none;
            padding: 16px 24px;
        }

        .template_review_wrapper {
            width: 100%;
            height: 780px;
            border-radius: 8px;
            background: #EDF0F4;
            padding: 16px;

            .handle_check_icon_wrap {
                display: block;
                width: 24px;
                height: 24px;
                opacity: 1;
                background: #FFFFFF;
                border: 1px solid #D9D9D9;
                border-radius: 50%;
                text-align: center;
                line-height: 24px;
                cursor: pointer;
                font-size: 10px;
                color: #666666;
                position: absolute;
                top: 50%;

                &:hover {
                    color: #4BA2FF;
                    border-color: #4BA2FF;
                }

                &.left {
                    left: 26px;
                }

                &.right {
                    right: 26px;
                }

                &.disabled {
                    background: #F7F7F7;
                    border-color: #D9D9D9;
                    color: #BFBFBF;
                    cursor: not-allowed;
                }
            }

            .template_review_image {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
</style>